'use strict';
const angular = require('angular');

export class stateChangeFormComponent {
  /*@ngInject*/
  constructor() {
    this.statusEnum = ["open","closed"];
  }

  $onInit = function () {
    //this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: {
      status: this.status,
      reason: this.reason
    }});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.stateChangeForm', [])
  .component('stateChangeForm', {
    template: require('./state-change-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: stateChangeFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/state-change-form/state-change-form.component.js